// extracted by mini-css-extract-plugin
export default {"wrapper":"ztnOrQ","wrapper--mobile":"vf44i7","message":"FOeTWn","contact":"iLH32k"};